<div class="profile-container">
    <div class="">
        <div class="profile-content">
  
            <div class="personal-details">
              <div class="header-block">
                <div class="header-title">
                    <p>Asset</p>
                </div>
                <div class="add-block">
                    <div class="search">
                        <form autocomplete="off" >
                            <input type="text" placeholder="search">
                        </form>
                        <i class="bi bi-search" ></i>
                    </div>
                    <button data-toggle="modal" data-target="#deviceModal"><i class="bi bi-plus-lg"></i> Add</button>
                </div>
            </div>
                <div class="row">
                  <div class="col-md-9 col-lg-9">
                    <div class="map-container">
                      <div class="map-frame">
                        <div id="map">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3 col-lg-3" style="padding-left: 0;">
                    <!-- <input type="text" placeholder="search" class="form-control"> -->
                    <div class="customerList">
                      <p *ngFor="let list of layerslist" (click)="getLayerInfoByLayerInfoId(list.layerInfoId)">{{list.layerName}}
                        <svg  (click)="seleteDeleteLayerId(list.id)"  data-toggle="modal" data-target="#deleteModal" style="cursor: pointer;" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash3" viewBox="0 0 16 16">
                          <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z"/>
                        </svg>
                      </p>
                      
                    </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
  </div>






  <button style="display: none;" id="add-layer-popup" data-toggle="modal" data-target="#exampleModal">Add Branch</button>

  <div class="modal fade" id="exampleModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Add Layer
            <span data-dismiss="modal">
              <i class="bi bi-x-lg"></i>
            </span>
          </h5>
        </div>
        <div class="modal-body">
    
          <div [formGroup]="form">
    
              <div class="form-group">
                  <label>Layer Name</label>
                  <input formControlName="layerName" type="text" class="form-control">
              </div>
              <div class="form-group">
                  <label>Layer Color</label>
                  <input formControlName="layerColor" type="color" class="form-control">
              </div> 
              <div class="form-group">
                <label>Layer Level</label>
                <input formControlName="layerLevel" type="text" class="form-control">
              </div> 
          </div>
    
     
        <div class="modal-footer">
          <button type="button" id="closeModalButton" (click)="remove()" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          <button type="button" (click)="addLayerInfo()" class="btn btn-primary">Add Layer</button>
        </div>
      </div>
    </div>
    </div>
  </div>




<button style="display: none;" id="add-device-popup" data-toggle="modal" data-target="#deviceModal">Add Branch</button>

<!-- <div class="modal fade" id="deviceModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Add Asset
          <span data-dismiss="modal">
            <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <div>
          <div class="form-group">
              <label>Name</label>
              <select name="" id="" class="form-control" (change)="getObjectTemplateById($event)">
                <option value="" selected disabled> -- object --</option>
                <option value="{{list.objectTemplateId}}" *ngFor="let list of objectTemplateList">{{list.name}}</option>
              </select>
          </div>
          <div *ngFor="let list of singleObjectTemplateData">
            <div class="form-group" *ngFor="let nameValue of list.nameValue">
              <div *ngIf="nameValue.key != 'Lat' && nameValue.key != 'Lng'">
                <label>{{nameValue.key}}</label>
                <input type="text" class="form-control" [(ngModel)]="nameValue.value">
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" id="closeModalButton1" (click)="remove()" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          <button type="button" (click)="addObjectInfo()" class="btn btn-primary">Save</button>
        </div>
      </div>
    </div>
  </div>
</div> -->

<div class="modal fade" id="deviceModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Add Asset
          <span data-dismiss="modal" (click)="remove()">
            <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <div>
          <div class="form-group">
              <label>Asset</label>
              <select name="" id="" [(ngModel)]="objectTemplateId" class="form-control"  (change)="getObjectTemplateById($event)">
                <option value="" selected disabled> -- Asset --</option>
                <option value="{{list.objectTemplateId}}" *ngFor="let list of objectTemplateList">{{list.name}}</option>
              </select>
          </div>
     
          <div *ngFor="let list of singleObjectTemplateData">

            <div class="form-group">
              <label>Name</label>
              <input type="text" class="form-control" [(ngModel)]="givenName">
            </div>

            <div class="form-group">
              <label>Serial Number</label>
              <input type="text" class="form-control" [(ngModel)]="serialNumber">
            </div>

            <div class="form-group">
              <label>Original Cost</label>
              <input type="text" class="form-control" [(ngModel)]="originalCost">
            </div>

            <div class="form-group">
              <label>Current Cost</label>
              <input type="text" class="form-control" [(ngModel)]="currentCost">
            </div>

            <div class="form-group">
              <label>Asset Condition</label>
              <select name="" id="" [(ngModel)]="objectCondition" class="form-control">
                <option value="" selected disabled> -- select condition --</option>
                <option value="Good">Good</option>
                <option value="UnderRepair">Under Repair</option>
                <option value="Scrap">Scrap</option>
              </select>
            </div>

            <div class="form-group" *ngIf="list.branch">
              <label>Branch</label>
              <select name="" id="" [(ngModel)]="branch" class="form-control">
                <option value="" selected disabled> -- select branch --</option>
                <option value="{{list.name}}" *ngFor="let list of branchList">{{list.name}}</option>
              </select>
            </div>

            <div class="form-group" *ngIf="list.department">
              <label>Department</label>
              <input type="text" class="form-control" [(ngModel)]="department">
            </div>

            <div class="form-group" *ngIf="list.make">
              <label>Make</label>
              <input type="text" class="form-control" [(ngModel)]="make">
            </div>

            <div class="form-group" *ngIf="list.model">
              <label>Model</label>
              <input type="text" class="form-control" [(ngModel)]="model">
            </div>

            <div class="form-group" *ngIf="list.location">
              <label>Location</label>
              <select name="" id="" [(ngModel)]="location" class="form-control">
                <option value="" selected disabled> -- select location --</option>
                <option value="{{list.city}}" *ngFor="let list of locationList">{{list.city}}</option>
              </select>
            </div>


          <div class="image-container">
            <div class="image-header image-header1">
              <h5>Images</h5>
              <i (click)="addTicketImageBtn()" class="bi bi-plus-circle"></i>
            </div>
            <div class="image-content-block">
              <div class="image-single" *ngFor="let image of imagesList">
                <!-- <i class="bi bi-x-lg"></i> -->
                <img src="{{image}}" (click)="selectLargeImage(image)" alt="">
                <!-- <p>remove</p> -->
              </div>
              <div class="large-image-view" *ngIf="largeImage != ''">
                <img src="{{largeImage}}" alt="">
                <button (click)="selectLargeImage('')">close</button>
              </div>
            </div>

            <div hidden="true">
              <input #imageInput
                        type="file" id="add-TicketImage-btn"
                        accept="image/*" hidden="true"
                        (change)="onTicketChange($event)">
            </div>
          </div>

            <div class="check-box">
                <p> Maintenance Schedule <i (click)="addMaintenance()" class="bi bi-plus-circle"></i></p>
            </div>

            <div class="maintenance-schedule-block">
              <div class="maintenance-schedule" *ngFor="let list of maintenanceList;let index = index">
                <span class="remove"><i (click)="removeMaintenance(index)" class="bi bi-x-lg"></i></span>

                <div class="form-group">
                  <label>Description</label>
                  <textarea name="" [(ngModel)]="list.description" class="form-control" id=""></textarea>
                </div>

                <div class="form-group">
                  <label>Maintenance Type</label>
                  <select name="" id="" [(ngModel)]="list.maintenanceType" class="form-control">
                    <option value="" selected disabled> -- select maintenance type --</option>
                    <option value="{{list.value}}" *ngFor="let list of maintenanceType">{{list.key}}</option>
                  </select>
                </div>

                <div class="form-group">
                  <label>Frequency Type</label>
                  <select name="" id="" [(ngModel)]="list.frequency" class="form-control">
                    <option value="" selected disabled> -- select frequency type --</option>
                    <option value="{{list.value}}" *ngFor="let list of frequencyType">{{list.key}}</option>
                  </select>
                </div>

                <div class="form-group">
                  <label>Next Due Date</label>
                  <input type="date" [min]="todayDate" class="form-control" [(ngModel)]="list.nextDueDate">
                </div>
              </div>
            </div>

            

                 <div class="multiple-inputs" *ngIf="list.nameValue && list.nameValue != null && list.nameValue != undefined && list.nameValue.length != 0">
              <h5 class="multi-title">Specifications</h5>
              <ul class="ui-tree">
                <ng-container *ngFor="let item of list.nameValue">
                  <ng-container *ngTemplateOutlet="renderNode; context: { $implicit: item }"></ng-container>
                </ng-container>
              </ul>

              <ng-template #renderNode let-node>
                <li>
                  <strong>{{ node.key }}:</strong> <span><input [(ngModel)]="node.value" style="width: 100%;" type="text"></span>
                  <ul *ngIf="node.keyValue && node.keyValue.length > 0">
                    <ng-container *ngFor="let child of node.keyValue">
                      <ng-container *ngTemplateOutlet="renderNode; context: { $implicit: child }"></ng-container>
                    </ng-container>
                  </ul>
                </li>
              </ng-template>
            </div>

    


            <div class="multiple-inputs" *ngIf="list.performanceMatrix && list.performanceMatrix != null && list.performanceMatrix != undefined && list.performanceMatrix.length != 0">
              <h5 class="multi-title">Performance</h5>

              <ul class="ui-tree">
                <ng-container *ngFor="let item of list.performanceMatrix">
                  <ng-container *ngTemplateOutlet="renderNode1; context: { $implicit: item }"></ng-container>
                </ng-container>
              </ul>

              <ng-template #renderNode1 let-node>
                <li>
                  <strong>{{ node.key }}:</strong> <span><input [(ngModel)]="node.value" style="width: 100%;" type="text"></span>
                  <ul *ngIf="node.keyValue && node.keyValue.length > 0">
                    <ng-container *ngFor="let child of node.keyValue">
                      <ng-container *ngTemplateOutlet="renderNode1; context: { $implicit: child }"></ng-container>
                    </ng-container>
                  </ul>
                </li>
              </ng-template>

            </div>




          </div>

        
        </div>
        <div class="modal-footer">
          <button type="button" id="closeModalButton1" (click)="remove()" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          <button type="button" (click)="addObjectInfo()" class="btn btn-primary">Save</button>
        </div>
      </div>
    </div>
  </div>
</div> 



<div class="modal fade" id="deleteModal" tabindex="-1" data-backdrop="static" aria-labelledby="deleteModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="deleteModalLabel">Confirmation!!
          <span data-dismiss="modal">
            <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <p>are you sure? want to delete??</p>
      <div class="modal-footer">
        <button type="button" id="deleteModalButton1" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
        <button type="button" (click)="deleteLayerInfo()" class="btn btn-primary">Delete</button>
      </div>
    </div>
  </div>
</div>
</div>
